/**
 * settlementHelpers.ts
 * 협력사 주정산내역 관련 유틸리티 함수 모음
 *
 * @description
 * - 정산 화면에서 사용하는 유틸리티 함수
 * - 컬럼 표시 권한 체크
 */
export { isExcelFile } from '@/shared/utils/validation';

// ============================================================
// 상수 정의
// ============================================================

/** 협력사 사용자에게 허용된 컬럼 인덱스 (Set으로 0(1) 조회) */
const SUPPLIER_ALLOWED_COLUMNS = new Set([2, 4, 5, 6, 7, 8, 9, 10, 11, 15, 16, 17, 18, 19, 22, 23]);

// ============================================================
// 권한 관련 함수
// ============================================================

/**
 * 사용자 권한에 따라 컬럼 표시 여부 결정
 *
 * @param columnIndex 컬럼 인덱스 (1부터 시작)
 * @param isSupplierUser 협력사 사용자 여부
 * @returns 컬럼 표시 여부
 */
export const shouldShowColumn = (columnIndex: number, isSupplierUser: boolean): boolean => {
    if (!isSupplierUser) return true;

    return SUPPLIER_ALLOWED_COLUMNS.has(columnIndex);
};
